// extracted by mini-css-extract-plugin
export default {"zoomModal":"x2-z"};